import qs from "qs";
import React, { createContext, ReactChild } from "react";
import PageConfig from "../../utils/PageConfig";

export interface DebugContextType {
  isDebug: boolean;
}

export const DebugContext = createContext<DebugContextType>({
  isDebug: false,
});

export interface DebugContextProviderProps {
  children?: ReactChild | ReactChild[] | undefined | null;
}

export const DebugContextProvider = (props: DebugContextProviderProps) => {
  const { children } = props;

  const queryParams = PageConfig.isSSR ? {} : qs.parse(window.location.search.substring(1));
  const debugParam = `${queryParams?.["debugPage"]}`;
  const isDebug = debugParam === "1" || debugParam?.toLowerCase() === "true";

  return <DebugContext.Provider value={{ isDebug }}>{children}</DebugContext.Provider>;
};
